import styled from 'styled-components'

// Icons
import { ReactComponent as ChevronRightIcon } from '@sketch/icons/chevron-right-16-svg'

export const Chevron = styled(ChevronRightIcon)`
  width: 16px;
  margin-left: auto;
  margin-right: 4px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const Wrapper = styled.section`
  padding: 16px 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.B};
`
